/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { IComponentProps } from '@msdyn365-commerce/core';
import React from 'react';

import { BusinessPartner, BusinessPartnersDataActions } from '@msdyn365-commerce/retail-proxy';
import { IDlvryBusinessPartnersResources } from '../dlvry-business-partners.props.autogenerated';
import { DataGrid, IDataGridColumn } from './data-grid';

/**
 * Props of IBusinessPartnersTable.
 */
export interface IBusinessPartnersTableProps extends IComponentProps {
    className: string;
    pageSize?: number;
    resources: IDlvryBusinessPartnersResources;
    onSelect(businessPartner: BusinessPartner): void;
}

export interface IBusinessPartnersTableState {
    businessPartners?: BusinessPartner[];
}

/**
 * BusinessPartnersTable component.
 */
export class BusinessPartnersTable extends React.Component<IBusinessPartnersTableProps, IBusinessPartnersTableState> {

    constructor(props: IBusinessPartnersTableProps) {
        super(props);
        this.state = {};
    }

    public shouldComponentUpdate(nextProps: Readonly<IBusinessPartnersTableProps>, nextState: Readonly<IBusinessPartnersTableState>): boolean {
        return this.props.id !== nextProps.id || this.state.businessPartners !== nextState.businessPartners;
    }

    public render(): JSX.Element {
        return (
            <DataGrid
                {...this.props}
                loadData={this.getBusinessPartners}
                columns={this.getColumns()}
                defaultSorting={{ fieldName: 'Name', ascending: true }}
                searchPlaceholderLabel={this.props.resources.businessPartnerSearchCompany}
            />
        );
    }

    /**
     * Get column definition of the table.
     * @returns - Columns.
     */
    private readonly getColumns = (): IDataGridColumn<BusinessPartner>[] => {
        return [
            {
                reactKey: 'businessPartnerId',
                name: 'ID',
                className: 'business-partner-users-header min-width',
                fieldName: 'BusinessPartnerId',
                isSearchable: true,
                onClick: this.props.onSelect
            },
            {
                reactKey: 'name',
                name: this.props.resources.businessPartnerName,
                className: 'business-partner-users-header',
                fieldName: 'Name',
                isSearchable: true,
                onClick: this.props.onSelect,
                onRender: (data: BusinessPartner) => <div className='business-partner-name'>{data.Name}</div>,
                onHeaderRender: (data) => <span className='business-partner-name-header'>{data.name}</span>
            }
        ];
    };

    /**
     * Call retail proxy to get business partners.
     * @returns - Business partners.
     */
    private readonly getBusinessPartners = async () => {
        if (this.state.businessPartners && this.state.businessPartners.length > 0) {
            return this.state.businessPartners;
        }

        const top = 1000;
        const businessPartners: BusinessPartner[] = [];

        let getNextPage = false;

        do
        {
            const businessPartnersPage = await BusinessPartnersDataActions.getManagedBusinessPartnersAsync({
                callerContext: this.props.context.actionContext,
                bypassCache: 'getAndPut',
                queryResultSettings: {
                    Paging: {
                        Top: top,
                        Skip: businessPartners.length
                    }
                }
            });

            if (businessPartnersPage && businessPartnersPage.length > 0)
            {
                businessPartners.push(...businessPartnersPage);
            }

            getNextPage = businessPartnersPage.length === top;
        }
        while (getNextPage);

        /* const businessPartners = await BusinessPartnersDataActions.getManagedBusinessPartnersAsync({
            callerContext: this.props.context.actionContext,
            bypassCache: 'getAndPut',
            queryResultSettings: {
                Paging: {
                    Top: top
                }
            }
        }); */

        this.setState({
            businessPartners: businessPartners
        });

        console.log('businessPartners: ', JSON.parse(JSON.stringify(businessPartners)));

        return businessPartners;
    };
}
